import React from 'react';
import { Stack, Link } from '@fluentui/react';

// import { useHover } from '../hooks';
import { classes } from '../../utils';

interface INavItemProps {
  icon: any;
  children: any;
  href: any;
  // isFavorite?: boolean;
  navID: any;
  // setFavorite: () => void;
  disableHover: boolean;
  onNavigate?: (path: string) => void;
}

const NavItem = ({
  icon,
  children,
  href,
  onNavigate,
  // isFavorite = false,
  //   navID,
  // setFavorite,
  // disableHover = false,
  ...props
}: INavItemProps) => (
  <Stack.Item
    className={classes.item}
    style={{ paddingLeft: 16 }}
    align='stretch'
    {...props}
  >
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Link
        className={classes.innerItem}
        href={href}
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          // Binnen de app navigeren i.p.v. de pagina te herladen: anders start alles opnieuw
          // (aanmelden, rechten, cache) en flitst kort het aanmeldscherm. Ctrl/Cmd/middelklik
          // opent nog altijd een nieuw tabblad via de gewone link.
          if (!onNavigate || !href || event.button !== 0
            || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          onNavigate(href);
        }}
      >
        <div>{icon}</div>
        <div>{children}</div>
      </Link>
      {/* {isFavorite && (
          <div className={classes.favoriteStar} onClick={() => setFavorite()}>
            <Icon iconName='FavoriteStarFill' className={classes.icon} />
          </div>
        )}
        {!isFavorite && isHovered && !disableHover && (
          <div className={classes.favoriteStar} onClick={() => setFavorite()}>
            <Icon iconName='FavoriteStar' className={classes.icon} />
          </div>
        )} */}
    </div>
  </Stack.Item>
);

export default NavItem;
